<template lang="pug">
  .firmware-version-filter
    span.filter-title {{ $t('transmitters.filters.firmware_version') }}
    el-select(
      v-model='selectedFirmwareVersion'
      filterable
      :placeholder="$t('placeholder.select_firmware_version')"
      @change="emitChangeEvent"
    )
      el-option(
        v-for='version in versions'
        :key='version.value'
        :label='version.label'
        :value="version.value"
      )
</template>

<script>
import axios from "axios";

export default {
  name: "FilterFirmwareVersion",

  props: {
    value: {
      type: String,
      default: "",
    },
  },

  computed: {
    selectedFirmwareVersion: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  data() {
    return {
      versions: [],
    };
  },

  async mounted() {
    await this.handleGetFirmwareVersions();
  },

  methods: {
    async handleGetFirmwareVersions() {
      const response = await axios.get('/v1/sensor_transmitters/firmware_versions');
      this.versions = response.data.data.map((version) => ({
        label: new Date(version).toLocaleString(),
        value: version,
      }));
      this.versions.unshift({ label: this.$t('common.all'), value: "" });
    },

    emitChangeEvent(values) {
      this.$emit('onChange', values);
    },
  },
};
</script>
